import * as React from "react"
import Usps from "@components/Usps"
import { UspItem } from "@components/Usps/types"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"

const StrapiUsps = ({
    content,
    content_images: contentImages,
    uspItems,
    uspsHeading
}: GatsbyTypes.UspsFragment) => {
    return <Usps
        content={parseContentImages(
            content,
            contentImages as ParseContentImagesProps[]
        )}
        uspsHeading={uspsHeading}
        uspItems={uspItems ? [...uspItems] as UspItem[] : undefined}
    />
}

export default StrapiUsps
